import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";

export type BooleanFlag =
  | "testFlag"
  | "engagementFeaturedQuestThemedBg"
  | "engagementDedicatedQuestDetailPage"
  | "engagementTakeoverEasterEgg"
  | "engagementGemfinity"
  | "playRqPromoBanner"
  | "moveSweepstakeEligibility"
  | "rewardsOnboardingCard"
  | "predictedKey"
  | "activationPanel"
  | "onboardingModalOct25";

type BooleanFlags = Record<BooleanFlag, boolean | undefined>;

export type ExperimentVariantValue = "VariantA" | "VariantB";

type SteamWishlistCaseStudy4Variant =
  | "wishlist-first-variant"
  | "link-first-variant";

type ActivationSpinnerRewardsOct25Variant = "control" | "variant";

type MultiValueFlags = {
  referralSept8: string | undefined;
  steamWishlistCaseStudy4: SteamWishlistCaseStudy4Variant | undefined;
  activationSpinnerRewardsOct25:
    | ActivationSpinnerRewardsOct25Variant
    | undefined;
};

// Flag values are undefined until they've been loaded
export type Flags = BooleanFlags & MultiValueFlags;

export function useFlag<T extends keyof Flags>(flag: T): Flags[T] {
  const flags = useLDFlags<Flags>();
  return flags[flag];
}

export function useFeatureFlags(): Flags {
  return useLDFlags<Flags>();
}
